import { render, staticRenderFns } from "./formularioCategoria.vue?vue&type=template&id=5c230af7&scoped=true"
import script from "./formularioCategoria.vue?vue&type=script&lang=js"
export * from "./formularioCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c230af7",
  null
  
)

export default component.exports